import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EntitlementGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const requiredEntitlements = route.data['entitlements'];

    if (!this.authService.hasEntitlements(requiredEntitlements)) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
